import React, { useMemo, useState, useEffect } from 'react';
import { useReportContext } from '../../context/DetailContext';
import styled from 'styled-components'
import { ACommonList } from '../../sidebar';
import LoanInfoService from '../../service/LoanInfo';
const iconExport = '/assets/images/icon/Icon_Export.svg'

const AttachmentFile = ({
  linkSet,
  caseInfo,
  setShowFileModal
}: {
  linkSet?: any;
  caseInfo?: any;
  setShowFileModal?: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const { type } = useReportContext();
  const [itemDetailButtonOn, setItemDetailButtonOn] = useState<boolean>(false);
  const [casDetailButtonOn, setCasDetailButtonOn] = useState<boolean>(false);
  const [dateDetailButtonOn, setDateDetailButtonOn] = useState<boolean>(false);
  const [deliveryButtonOn, setDeliveryButtonOn] = useState<boolean>(false);
  const [statusServeryButtonOn, setStatusServeryButtonOn] = useState<boolean>(false);
  const iidx = caseInfo?.iidx;
 // 버튼 리스트 구성
  const fileButtons = useMemo(() => {
    return [
      {
        title: '매각물건명세서',
        link: linkSet?.buttonLink?.assetDetail || '',
      },
      {
        title: '감정평가서',
        link: linkSet?.buttonLink?.appraisal || '',
      },
      {
        title: '현황조사서',
        link:
          statusServeryButtonOn && iidx
            ? linkSet?.buttonLink?.statusServery || `/statusServey?iidx=${iidx}`
            : '',
      },
      {
        title: '토지 등기',
        link: linkSet?.buttonLink?.landRegister || '',
      },
      {
        title: '물건 상세',
        link: iidx ? `/itemDetail?iidx=${iidx}` : '',
        disabled: !itemDetailButtonOn,
      },
      {
        title: '사건내역',
        link: iidx ? `/incidentDetail?iidx=${iidx}` : '',
        disabled: !casDetailButtonOn,
      },
      {
        title: '기일내역',
        link: iidx ? `/dateDetail?iidx=${iidx}` : '',
        disabled: !dateDetailButtonOn,
      },
      {
        title: '문건/송달 내역',
        link: deliveryButtonOn && iidx
            ?
          linkSet?.buttonLink?.documentsHistory || `/documentDetail?iidx=${caseInfo.iidx}` : '',
        disabled: !deliveryButtonOn,
      },
    ];
  }, [linkSet, iidx, itemDetailButtonOn, casDetailButtonOn, dateDetailButtonOn, statusServeryButtonOn, deliveryButtonOn]);

  // API 호출: 상세 버튼 상태
  useEffect(() => {
    if (type === 's') return;
    if (iidx) {
      getDetailButtonStates(iidx);
    }
  }, [type, iidx]);

  const getDetailButtonStates = async (iidx: number) => {
    try {
      const res = await LoanInfoService.courtDetail(iidx);
      if (res.data.item_detail?.basic_info?.case_no != null) {
        setItemDetailButtonOn(true);
      }
      if (res.data.case_detail?.basic_info?.case_no != null) {
        setCasDetailButtonOn(true);
      }
      if (res.data.date_list != null) {
        setDateDetailButtonOn(true);
      }
    } catch (e) {
      console.error(e);
    }
  };

  // API 호출: 현황조사서 / 문건송달
  useEffect(() => {
    if (iidx) {
      getStatusServeyData(iidx);
      getDeliveryData(iidx);
    }
  }, [iidx]);

  const getStatusServeyData = async (iidx: number) => {
    try {
      const res = await LoanInfoService.statusServey(iidx);
      setStatusServeryButtonOn(!!res.data?.top);
    } catch (e) {
      console.error(e);
      setStatusServeryButtonOn(false);
    }
  };

  const getDeliveryData = async (iidx: number) => {
    try {
      const res = await LoanInfoService.documentDelivery(iidx);
      const hasData = res.data?.date_list?.length > 0 && res.data?.date_list2?.length > 0;
      setDeliveryButtonOn(hasData);
    } catch (e) {
      console.error(e);
      setDeliveryButtonOn(false);
    }
  };

  return (
    <div>
      <DetailContainer>
        <TitleWrapper>
          <AttchmentTitle>첨부파일</AttchmentTitle>
          <ExportButton onClick={() => setShowFileModal?.(true)}>
            <img src={iconExport} alt="내보내기" />
            일괄 내보내기
          </ExportButton>
        </TitleWrapper>

        <ContentWrapper>
          {fileButtons.map((item, idx) => {
            const isDisabled = !item.link || item.disabled;
            return (
              <ContentBox
                key={idx}
                onClick={() => {
                  if (isDisabled) return;
                  window.open(item.link, '_blank');
                }}
                style={{
                  opacity: isDisabled ? 0.2 : 1,
                  pointerEvents: isDisabled ? 'none' : 'auto',
                  cursor: isDisabled ? 'not-allowed' : 'pointer',
                }}
              >
                {item.title}
              </ContentBox>
            );
          })}
        </ContentWrapper>
      </DetailContainer>
    </div>
  );
};

export default AttachmentFile
const DetailContainer = styled.div`
  width: 100%;
  height: fit-content;
  padding: 32px 16px;
  background-color: #ffffff;
`;

const AttchmentTitle = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #fff;
  gap: 24px;
  color: #222222;
  font-size: 18px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 700;
  line-height: 26.1px;
  word-wrap: break-word;
`

const ExportButton = styled.span`
  border: 1px solid rgb(229, 232, 234);
  border-radius: 4px;
  padding: 4px 6px;
  font-size: 14px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  line-height: 14.5px;
  word-wrap: break-word;
  display: flex;
  align-items: center;
  gap: 2px;
  cursor: pointer;
`
const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
`

const ContentWrapper = styled.div`
  padding: 12px 16px;
  border: 1px solid #70737C29;
  border-radius: 8px;
`
 
const ContentBox = styled.div`
  padding: 12px 0;
  border-bottom: 1px solid #70737C29;
  font-size: 14px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  line-height: 26.1px;
  word-wrap: break-word;
  cursor: pointer;
  &:first-child {
  padding: 4px 0 12px;
  }
  &:last-child {
  padding: 12px 0 0;
  border: none;
  }
`